angular.module('edxComponents')
  .component('edxLegacyNweaScoreRangeDropdown', {
    templateUrl: '/resources/components/assign-focus/create-nwea-assignment/nwea-score-range-dropdown.component.html',
    controller: ['edxLegacyNweaAssignmentService', NweaScoreRangeDropdownController],
    controllerAs: 'vm',
    bindings: {
      studentId: '<edxStudentId',
      domainId: '<edxDomainId',
      onSelect: '&edxOnSelect'
    }
  });

function NweaScoreRangeDropdownController(nweaAssignmentService) {
  var vm = this;

  vm.$onChanges = $onChanges;
  vm.isDisabled = isDisabled;
  vm.onClick = onClick;

  vm.loading = false;
  vm.scoreRanges = [];
  vm.selected = undefined;

  var lastSentValue;

  function $onChanges(changes) {
    if (changes.domainId || changes.studentId) {
      _refreshScoreRanges();
    }
  }

  function _refreshScoreRanges() {
    if (vm.studentId && vm.domainId) {
      vm.loading = true;
      nweaAssignmentService.loadScoreRangesForStudent(vm.studentId, vm.domainId).then(function (scores) {
        vm.scoreRanges = scores;
        vm.selected = undefined;
      }).catch(function () {
        vm.scoreRanges = [];
      }).finally(function () {
        vm.loading = false;
        _sendSelectionIfChanged();
      });
    } else {
      vm.scoreRanges = [];
      vm.selected = undefined;
      _sendSelectionIfChanged();
    }
  }

  function isDisabled() {
    return !vm.scoreRanges || vm.scoreRanges.length <= 0 || vm.loading;
  }

  function onClick(model) {
    _sendSelectionIfChanged();
  }

  function _sendSelectionIfChanged() {
    var model = vm.selected;
    if (lastSentValue !== model) {
      lastSentValue = model;
      vm.onSelect({scoreRange: model});
    }
  }
}
